export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("page:finish", () => {
    const route = useRoute();
    const router = useRouter();
    const { $toast } = useNuxtApp();

    nextTick(() => {
      const { toastMessage, toastType, ...restQuery } = route.query;

      if (toastMessage) {
        // Use a switch or if/else to handle different toast types
        switch (toastType) {
          case "success":
            $toast.success(toastMessage as string);
            break;
          case "error":
            $toast.error(toastMessage as string);
            break;
          case "info":
            $toast.info(toastMessage as string);
            break;
          default:
            $toast(toastMessage as string);
        }

        // Use router.replace to update the URL without adding a new history entry.
        router.replace({ query: restQuery });
      }
    });
  });
});
